import React from 'react'

export const Header = ({ children }: { children: React.ReactNode }) => (
  <section className='row no-gutters d-flex justify-content-between'>
    {children}
  </section>
)
